module.exports = __webpack_public_path__ + "img/glazov.8a2a3cb9.jpg";